'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var color = require('@pixi/color');
var deprecation = require('../logging/deprecation.js');

function hex2rgb(hex, out = []) {
  deprecation.deprecation("7.2.0", "utils.hex2rgb is deprecated, use Color#toRgbArray instead");
  return color.Color.shared.setValue(hex).toRgbArray(out);
}
function hex2string(hex) {
  deprecation.deprecation("7.2.0", "utils.hex2string is deprecated, use Color#toHex instead");
  return color.Color.shared.setValue(hex).toHex();
}
function string2hex(string) {
  deprecation.deprecation("7.2.0", "utils.string2hex is deprecated, use Color#toNumber instead");
  return color.Color.shared.setValue(string).toNumber();
}
function rgb2hex(rgb) {
  deprecation.deprecation("7.2.0", "utils.rgb2hex is deprecated, use Color#toNumber instead");
  return color.Color.shared.setValue(rgb).toNumber();
}

exports.hex2rgb = hex2rgb;
exports.hex2string = hex2string;
exports.rgb2hex = rgb2hex;
exports.string2hex = string2hex;
//# sourceMappingURL=hex.js.map
